import PropTypes from 'prop-types';
import { Cascader } from 'antd';
import cx from 'classnames';
import { LocationIcon } from '@ring-icons';
import isWebView from '$src/utils/user-agent';
import { Input } from '@amzn/ring-react-components/csr/components/Input';

import './index.less';

export default function SearchLocation({ onChangeSearchLocations, onApplySetupIncompleteFilter, onApplySetupCompleteFilter, onApplyClearFilter }) {
  const options = [
    {
      value: 'all',
      label: 'All Locations',
    },
    {
      value: 'complete',
      label: <span data-testid="select-setup-completed">Setup Completed</span>,
    },
    {
      value: 'incomplete',
      label: <span data-testid="select-setup-incomplete">Setup Incomplete</span>,
    },
  ];

  const onChangeOnboardStatus = (value) => {
    if (value[0] === 'complete') {
      onApplySetupCompleteFilter();
    } else if (value[0] === 'incomplete') {
      onApplySetupIncompleteFilter();
    } else if (value[0] === 'all') {
      onApplyClearFilter();
    }
  };

  return (
    <div className={cx('search-location', { 'avoid-autofocus': isWebView()})} data-testid="search-location">
      <Input icon={<LocationIcon aria-hidden />} placeholder="Search for locations" onChange={onChangeSearchLocations} type="text" />
      <div className="search-location__filters">
        <span>Filter by</span>
        <Cascader
          data-testid="search-location-filter"
          allowClear={false}
          defaultValue={'all'}
          size="large"
          options={options}
          onChange={onChangeOnboardStatus}
        />
      </div>
    </div>
  );
}

SearchLocation.propTypes = {
  onChangeSearchLocations: PropTypes.func.isRequired,
  onApplySetupIncompleteFilter: PropTypes.func.isRequired,
  onApplySetupCompleteFilter: PropTypes.func.isRequired,
  onApplyClearFilter: PropTypes.func.isRequired,
};
